










































































import { ILocale } from "@/@types/locale";
import { Component, Prop, Inject, Watch, Vue } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import BSwitch from "@/components/app/switchs/b-switch.vue";
import UploadPicture from "@/components/app/images/upload-picture.vue";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import ButtonLocales from "@/components/buttons/button-locales.vue";
import StandartModal from "@/components/app/standart-modal.vue";

export interface ICategory {
  _id: string;
  name: ILocale;
  show: boolean;
  sort_order: number | undefined;
  src: {
    poster: string;
    background: string;
  };
}

@Component({
  components: {
    StandartModal,
    UploadPicture,
    submit: SubmitResetButtonGroop,
    BSwitch,
    ButtonLocales,
  },
  mixins: [validationMixin],
  validations: {
    name: { required },
  },
})
export default class StandartCategoryForm extends Vue {
  @Inject({ from: "categoryFolder", default: "" }) readonly folder!: string;
  @Inject({ from: "categoryBgFolder", default: "" }) readonly bgfolder!: string;

  @Prop({ type: Object, default: null }) item!: ICategory;
  @Prop({ type: String, default: "category-form" }) modal!: string;

  locale = this.$store.getters.getLanguages[0];

  show = true;
  name = "";
  poster = "";
  background = "";
  names: ILocale = {};

  get category(): Partial<ICategory> {
    return {
      _id: this.item ? this.item._id : "",
      name: this.names,
      show: this.show,
      src: {
        poster: this.poster,
        background: this.background,
      },
    };
  }

  @Watch("name")
  addNameValue(): void {
    this.names[this.locale] = this.name;
  }

  @Watch("locale")
  updateNameValue(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }

    const id = this.item ? this.item._id : "";
    this.$emit("change", this.category, id);
  }
  onReset(): void {
    this.name = "";
    this.poster = "";
    this.background = "";
    this.show = false;
    this.names = {};
  }

  @Watch("item")
  autoCreater(): void {
    if (!this.item) return;
    this.names = this.item.name;
    this.poster = this.item.src.poster;
    this.background = this.item.src.background;
    this.show = this.item.show;
    this.updateNameValue();
  }
}
